import inherits from 'inherits';

import Viewer from './Viewer';

import KeyboardMoveModule from 'diagram-js/lib/navigation/keyboard-move';
import MoveCanvasModule from 'diagram-js/lib/navigation/movecanvas';
import ZoomScrollModule from 'diagram-js/lib/navigation/zoomscroll';

export default function NavViewer(options) {
  Viewer.call(this, options);
}

inherits(NavViewer, Viewer);

NavViewer.prototype._navigationModules = [
  KeyboardMoveModule,
  MoveCanvasModule,
  ZoomScrollModule
];

NavViewer.prototype._modules = [].concat(
  Viewer.prototype._modules,
  NavViewer.prototype._navigationModules
);